module.exports = __webpack_public_path__ + "src/komponente/izvestaj/pozadina.017c5d0aade449ea7ef9b48846498233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/komponente/izvestaj/pozadina.jpg
// module id = 31
// module chunks = 0